import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Grid, GridItem, Skeleton, Stack, Text } from '@bonusly/design-system';

interface UserPopoverActivitySectionProps {
	given?: number;
	received?: number;
	isLoading: boolean;
}
export const UserPopoverActivitySection: FC<UserPopoverActivitySectionProps> = ({ isLoading, given, received }) => {
	const { t } = useTranslation('components');

	if (isLoading) {
		return (
			<Stack test-dataid="user-popover-activity-loading">
				<Skeleton height="20px" />
				<Skeleton height="20px" />
				<Skeleton height="20px" />
			</Stack>
		);
	}

	if (given === undefined || received === undefined) {
		return null;
	}

	return (
		<Grid gap={2} templateColumns="repeat(5, 1fr)" alignItems="center">
			<GridItem colSpan={5}>
				<Text fontSize="sm" color="text.softer">
					{t('user_popover.last_days', { count: 60 })}
				</Text>
			</GridItem>
			<GridItem colSpan={4}>
				<Text fontSize="sm" color="text.default">
					{t('user_popover.given')}
				</Text>
			</GridItem>
			<GridItem colSpan={1} justifySelf="end">
				<Text fontSize="sm" variant="strong" color="text.default" style={{ fontVariantNumeric: 'tabular-nums' }}>
					{given}
				</Text>
			</GridItem>
			<GridItem colSpan={4}>
				<Text fontSize="sm" color="text.default">
					{t('user_popover.received')}
				</Text>
			</GridItem>
			<GridItem colSpan={1} justifySelf="end">
				<Text fontSize="sm" variant="strong" color="text.default" style={{ fontVariantNumeric: 'tabular-nums' }}>
					{received}
				</Text>
			</GridItem>
		</Grid>
	);
};
